import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { IdentifiersListTuner } from '../IdentifiersListTuner';

export class IdentifiersListTuneCommand implements ICommand {
  private readonly _tuner: IdentifiersListTuner;

  private readonly _descriptor: string;

  private readonly _val: string;

  private _prevVal: string;

  public constructor(tuner: IdentifiersListTuner, descriptor: string, val: string) {
    this._tuner = tuner;
    this._descriptor = descriptor;
    this._val = val;
    this._prevVal = this._tuner.getValue(descriptor);
  }

  public execute(): Promise<boolean> {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._tuner.setValueAsync(this._descriptor, this._val);
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._tuner.setValueAsync(this._descriptor, this._prevVal);
    return Promise.resolve(false);
  }
}
